export default __webpack_public_path__ + "ernie-botca8d33.png";